export const addEssentialsListToCart = (teacherId, amount, onSuccess, onFailure) => {
    $.ajax({
        // jsonp is terrible! But we need to hit `secure` from `www` here (hitting checkout from search). The *correct*
        // way to do that is via OPTIONS preflight requests, but we don't seem to have that set up correctly yet.
        type: 'GET',
        dataType: 'jsonp',

        url: secureBaseURL + 'donors/givingCart.html',
        data: {
            gift: true,
            essentialsListTeacherId: teacherId,
            amount,
        },
    }).done(onSuccess)
        .fail(onFailure);
}

